import React from 'react';
import Helmet from "../components/Helmet/Helmet";
import CommonSection from "../components/UI/CommonSection";

function Privacy() {
  return (
    <Helmet title="Privacy Policy">
      <CommonSection title="Privacy Policy" />
      <div className="max-w-2xl mx-auto mt-8">
        <p className="mb-4">
          Welcome to Aspect Car Rental Services. Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website and services.
        </p>

        <h2 className="text-2xl font-semibold mb-2">1. Information We Collect</h2>
        <p className="mb-4">
          We collect information you provide directly to us, such as when you make a reservation, contact customer support, or interact with our website. This may include personal information such as your name, contact details, and payment information.
        </p>

        <h2 className="text-2xl font-semibold mb-2">2. How We Use Your Information</h2>
        <p className="mb-4">
          We use the information we collect to provide and improve our services, process your reservations, communicate with you, and personalize your experience. We may also use your information for marketing purposes, but you can opt out at any time.
        </p>

        <h2 className="text-2xl font-semibold mb-2">3. Information Sharing</h2>
        <p className="mb-4">
          We do not sell, trade, or otherwise transfer your personal information to outside parties. This does not include trusted third parties who assist us in operating our website or servicing you, as long as those parties agree to keep this information confidential.
        </p>

        <h2 className="text-2xl font-semibold mb-2">4. Security</h2>
        <p className="mb-4">
          We implement a variety of security measures to maintain the safety of your personal information. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
        </p>

        <h2 className="text-2xl font-semibold mb-2">5. Your Choices</h2>
        <p className="mb-4">
          You have the right to access, correct, or delete your personal information. You may also choose not to provide certain information, but this may limit your ability to use some features of our services.
        </p>

        <h2 className="text-2xl font-semibold mb-2">6. Changes to This Privacy Policy</h2>
        <p className="mb-4">
          We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
        </p>

        <p>
          If you have any questions or concerns about our Privacy Policy, please contact us at privacy@aspectcarrental.com.
        </p>
      </div>
    </Helmet>
  );
}

export default Privacy;
